import type { Components } from 'react-markdown';

import { Link, Typography } from '@mui/material';

export const MARKDOWN_COMPONENTS: Components = {
  p: ({ children }) => <Typography>{children}</Typography>,
  a: ({ href, children }) => (
    <Link href={href} target="_blank" rel="noopener noreferrer">
      {children}
    </Link>
  ),
};
